import React from "react"
import MedicalDecor from "./MedicalDecor"
import logo from "../asset/images/logo.svg"

const AuthLayout = ({ title, subtitle, children }) => {
  return (
    <section className="min-h-dvh min-h-screen bg-gray-50">
      <div className="mx-auto grid min-h-dvh min-h-screen w-full max-w-6xl grid-cols-1 md:grid-cols-2">
        <div className="flex flex-col justify-center px-6 py-10 sm:px-10">
          <a href="/" onClick={(e) => { e.preventDefault(); window.location.href = "/" }} className="mb-8 flex items-center gap-2 text-2xl font-semibold text-gray-900">
            <img className="h-8 w-8 -mt-0.5" src={logo} alt="Employ Me logo" />
            <span className="leading-none tracking-tight">EmployMeGlobal</span>
          </a>
          <div className="w-full rounded-lg bg-white shadow sm:max-w-md md:max-w-lg">
            <div className="p-6 sm:p-8 md:p-10">
              {title ? (
                <h1 className="text-2xl font-bold leading-tight tracking-tight text-gray-900">
                  {title}
                </h1>
              ) : null}
              {subtitle ? (
                <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
              ) : null}
              <div className="mt-6">{children}</div>
            </div>
          </div>
        </div>
        <div className="hidden items-center justify-center md:flex">
          <MedicalDecor />
        </div>
      </div>
    </section>
  )
}

export default AuthLayout


